export * from './color-bar.component';
